import { Component, ElementRef, OnInit, Output, ViewChild } from '@angular/core';
import { StandardProcessService } from 'src/app/appServices/DefineService/standardProcess-service';
import { LocalStorage, MenuItemsAccess } from 'src/app/appCommon/Enums/enum';
import { HelperService } from 'src/app/appServices/HelperService/helper.service';
import { ToasterService } from 'src/app/appServices/ToasterService/toaster.service';
import { MessageService } from 'primeng/api';
import { DatePipe } from '@angular/common';
import { PiteamService } from 'src/app/appServices/DefineService/piTeam-service';
import { FileUploadComponent } from '../file-upload/file-upload.component';
import { Subscription } from 'rxjs';
import { allStanderdProcessPages } from 'src/app/appWeb/shared/shared';
import { AccessControlService } from 'src/app/appServices/CommonService/access-control.service';
import { StickyNote, note, rowArrayPrePostAndVSM } from 'src/app/appWeb/shared/shared-interface';
import { AuthService } from 'src/app/appServices/AuthService/auth.service';
import { DefineService } from 'src/app/appServices/DefineService/define-service';
import { DownloadHelperService } from 'src/app/appServices/DownloadHelperService/download-helper.service';
const { v4: uuidv4 } = require('uuid');

@Component({
  selector: 'app-triage-walk-in',
  templateUrl: './triage-walk-in.component.html',
  styleUrls: ['./triage-walk-in.component.scss'],
})
export class TriageWalkInComponent implements OnInit {
 
  rows:number = 15;
  sortOrder:string = 'Asc';
  sortCol:string = '';
  filterVal:string = '';
  cols: any;
  noRecordBool!: boolean;
  @Output() totalRecords:number = 0;
  addNotesArray: Array<any> = [];
  notespre: Array<any> = [];
  notespost: Array<any> = [];
  notespostVSM:Array<any> = [];
  rowClicked!: number;
  historyBool: boolean = false;
  textArray: Array<string> = [];
  childComponentNavigate = 'childComponentNavigate';
  getStickyNotesData: Array<StickyNote> = [];
  checked: boolean = false;
  updateNotesArray: Array<any> = [];
  noteID: string = '';
  workflowType: string = '';
  type: string = '';
  notespreTemp: Array<any> = [];
  notespostTemp: Array<any> = [];
  notespostVSMTemp: Array<any> = [];
  onClickDisable: boolean = true;

  rowNO: any;
  // rowArray:any = [];
  rowArrayPre:Array<rowArrayPrePostAndVSM> = [];
  rowArrayPost:Array<rowArrayPrePostAndVSM> = [];
  rowArrayPostVSM:Array<rowArrayPrePostAndVSM> = [];
  postBool: boolean = false;
  qsp_type: string = '';

  showProgressSpinner: boolean = false;
  facilityKey: string | null = '';
  implentationType:string | null = '';
  preImplementationBool:boolean = false;
  totalRecordsCurrentFutureBool:boolean = false;
  totalRecordsCurrentBool:boolean = false;
  totalRecordsFutureBool:boolean = false;
  AddPostVSMBool: boolean = false;

  selectDatePostVSM:Date | string | null = new Date();
  storePreviousDateVSM:string = '';
  datePipe = new DatePipe('en-US');
  alreadyExistedVarBool: boolean = false;
  isCurrentStateFirstTime: boolean = false;
  isFutureStateFirstTime: boolean = false;
  isPostImplementationVSMFirstTime: boolean = false;
  colorScheme:string='';
  notespostVSMForRowAndID:Array<note> = [];
  alreadyExistedVar:string = '';
  No : number = 0;
  allStanderdProcessPages = allStanderdProcessPages;
  defaultText: string = '';
  roleAccessResult:Array<any> = [];
  isAccessReadWrite:boolean = false;
  marginFirstBool: boolean = false;
  noForAccordian:number = 0;
  componentName: string | null = '';
  navigatePage:string = '';
  @Output() isAccessRead: boolean = false;
  pageTittleName: string = 'Pre Implementation';
  workFlow_type:number = 1;
  @Output() getFileUploadStandardProcessArray:any = [];
  @ViewChild(FileUploadComponent) selectedDropdownValue:any = '';
  @ViewChild(FileUploadComponent) selectedUploadDate:any = new Date();
  @ViewChild(FileUploadComponent) selectedFilesBase64Array:any;
  unique_Id: number | string = '';
  triageFileLoader:boolean = false;
  private subscription: Subscription[] = [];
  UploadDocBool: boolean=true;
  deletePostVsmAccordionBool: boolean= false;
  accordionNo: number = 0;
  accordionDate!: Date | string;
  @Output() roleForFacility: boolean = false;

  constructor(
    public standardProcessService: StandardProcessService,
    private helperService: HelperService,
    public el: ElementRef,
    private toastService: ToasterService,
    private messageService: MessageService,
    public PiTeamService: PiteamService,
    private accessControlService: AccessControlService,
    private authService: AuthService,
    private defineService: DefineService,
    private downloadHelper: DownloadHelperService,
  ) {}

  ngOnInit(): void {
    this.roleForFacility = this.authService.roleForFacility();
    this.standardProcessService._standerdProcessComponent.TriageWalkInComponent = this;
    this.componentName = localStorage.getItem("componentName");
    if(this.componentName != null && this.componentName != ""){
      this.navigatePage = this.componentName;
    }
    this.facilityKey = localStorage.getItem('facilityKey');
    this.implentationType = localStorage.getItem('implentationType');
    if (this.implentationType == 'Pre Implentation') {
      this.preImplementationBool = true;
      this.pageTittleName = 'Pre Implementation';
    } else {
      this.preImplementationBool = false;
      this.pageTittleName = 'Post Implementation'
    }
    this.addNotesArray = [];
    this.GetNotesData();
    let bool = localStorage.getItem('sdfgs')
    if(bool != null){
      this.isPostImplementationVSMFirstTime = Boolean(bool);
    }
    this.ViewDownloadedDocument();
  }
  CheckValueForUpload(value:any){
    this.UploadDocBool = value;
  }
 
  GetNotesData() {
    this.showProgressSpinner = true;
    this.rowArrayPre = [];
    this.rowArrayPost = [];
    this.notespostVSM = [];
    this.subscription.push(
    this.standardProcessService.GetStandardProcess(3, this.facilityKey).subscribe({
      next: (res: any) => {
        this.showProgressSpinner = false;
        this.noForAccordian = 0;
        this.getStickyNotesData = res.data;
        this.getSavedData();
     
        const accessData = this.accessControlService.checkAccess( MenuItemsAccess.StandardProcessRead, MenuItemsAccess.StandardProcessReadWrite);
        this.isAccessRead = accessData.isAccessRead;
        this.isAccessReadWrite = accessData.isAccessReadWrite;
      },
      error: (err: any) => { },
    })
    );
  }

getSavedData(){
  if (this.getStickyNotesData.length > 0) {
    this.getStickyNotesData.forEach((element: any, index: any) => {
      if (element.qsp_type == 'preworkflow') {
        this.isCurrentStateFirstTime = true;
        let index = this.notespre.findIndex(
          (d: any) => d.row == element.qsp_row_no
        );
        if (this.notespre.length && index > -1) {
          this.notespre[index].id.push({
            id: element.qsp_text_id,
            text: element.qsp_text,
            color: element.qsp_background_color,
            row: element.qsp_row_no,
            qsp_key: element.qsp_key,
          });
        } else {
          this.notespre.push({
            row: element.qsp_row_no,
            color: element.qsp_background_color,
            id: [
              {
                id: element.qsp_text_id,
                text: element.qsp_text,
                qsp_key: element.qsp_key,
              },
            ],
          });
        }
       this.totalRecordsCurrentBool = true;
      }
      else if (element.qsp_type == 'postworkflow') {
        this.isFutureStateFirstTime = true;
        let index = this.notespost.findIndex(
          (d: any) => d.row == element.qsp_row_no
        );
        if (this.notespost.length && index > -1) {
          this.notespost[index].id.push({
            id: element.qsp_text_id,
            text: element.qsp_text,
            color: element.qsp_background_color,
            row: element.qsp_row_no,
            qsp_key: element.qsp_key,
          });
        } else {
          this.notespost.push({
            row: element.qsp_row_no,
            color: element.qsp_background_color,
            id: [
              {
                id: element.qsp_text_id,
                text: element.qsp_text,
                qsp_key: element.qsp_key,
              },
            ],
          });
        }
    this.totalRecordsFutureBool = true;
      }
      else if (element.qsp_type == 'postworkflowVSM') {
        this.isPostImplementationVSMFirstTime = true;
        let noForAccordian = 0;
        let VSMindex = this.notespostVSM.findIndex(
          (d: any) => d.date == this.datePipe.transform(element.qsp_starting_date, 'MM/dd/yyyy')
        );
        if (this.notespostVSM.length && VSMindex > -1) {
          this.notespostVSMForRowAndID = [];
          this.notespostVSMForRowAndID.push({
            row: element.qsp_row_no,
            color: element.qsp_background_color,
            id: [
              {
                id: element.qsp_text_id,
                text: element.qsp_text,
                qsp_key: element.qsp_key,
              },
            ]
          });
          let a = this.notespostVSM[VSMindex].value.find((d:any) => d.row == this.notespostVSMForRowAndID[0].row)
          if (a) {
            a.id.push(this.notespostVSMForRowAndID[0].id[0]);
          }
          else {
            this.notespostVSM[VSMindex].value.push(this.notespostVSMForRowAndID[0]);
          }
        }
        else {
          this.notespostVSMForRowAndID = [];
          this.notespostVSMForRowAndID.push({
            row: element.qsp_row_no,
            color: element.qsp_background_color,
            id: [
              {
                id: element.qsp_text_id,
                text: element.qsp_text,
                qsp_key: element.qsp_key,
              },
            ]
          });
          this.noForAccordian += 1
          this.notespostVSM.push({
            accordion: this.noForAccordian,
            value: this.notespostVSMForRowAndID,
            date: this.datePipe.transform(element.qsp_starting_date, 'MM/dd/yyyy')
          });
        }
        this.selectDatePostVSM = element.qsp_starting_date
      }
      this.qsp_type = element.qsp_type
    });
    this.addNotesArray = [];
    if(this.notespostVSM.length > 0){
      this.notespostVSM = this.notespostVSM.sort((a: any, b: any) => {
        const dateA = new Date(a.date);
        const dateB = new Date(b.date);
        return dateB.getTime() - dateA.getTime();
      });
    }

  }
  else {
    this.AddDefaultPreWorkFlow();
    this.AddDefaultPostWorkFlow();
    this.totalRecordsCurrentFutureBool = true;
  }
  if (this.notespre.length <= 0) {
    this.AddDefaultPreWorkFlow();
  }
  if (this.notespost.length <= 0) {
    this.AddDefaultPostWorkFlow();
  }
  if (this.notespostVSM.length > 0) {
    this.AddPostVSMBool = true;
  }
  this.selectDatePostVSM= new Date();
}

  AddUpdateNoteData(event: Event, note: note, index: number, qspType: string, id: string, noteIdx:number) {
    this.onClickDisable = false;
    if (event.type == 'blur') {
      let oldText, OldId, OldQspkey;
      let json = {};
      const target = (event.target as HTMLElement);
      let text = target?.innerText.replace(/(?:\r\n|\r|\n)/g, '\n') || '';
      text = text.replace(/\n{2}/g, '\n');
      if (index > -1 && text != 'Save') {
        this.textArray[index] = text;
      }
      if (qspType == 'preworkflow') {
        this.notespre.map((d: any) => {
          d.id.map((e: any) => {
            if (e.id == id) {
              oldText = e.text;
              OldId = e.id;
              OldQspkey = e.qsp_key;
            }
          });
        });
      }
      else if (qspType == 'postworkflow') {
        this.notespost.map((d: any) => {
          d.id.map((e: any) => {
            if (e.id == id) {
              oldText = e.text;
              OldId = e.id;
              OldQspkey = e.qsp_key;
            }
          });
        });
      }

      if (OldId == id && oldText != this.textArray[index] && OldQspkey != undefined) {
        json = {
          qsp_key: OldQspkey,
          qsp_text_id: id,
          qsp_text: this.textArray[index],
          qsp_background_color: note.color,
          qsp_row_no: note.row,
          qsp_workflow_type: 3,
          qsp_fac_key:this.facilityKey,
          qsp_type: qspType,
          qsp_starting_date: this.standardProcessService.getTodayDate(),
          qsp_modified_by: this.helperService.decryption(localStorage.getItem(LocalStorage.UId)),
          qsp_modified_by_name: this.helperService.decryption(localStorage.getItem(LocalStorage.UName)),
          qsp_modified_by_date: '',
          qsp_row_note_index: noteIdx
        };
        if (qspType == 'preworkflow') {
          this.updateNotesArray.forEach((element: any, index: any) => {
            element.qsp_row_note_index == noteIdx && element.qsp_row_no == note.row ? this.updateNotesArray.splice(index,1) : ''
           });
        }
        else if (qspType == 'postworkflow') {
          this.updateNotesArray.forEach((element: any, index: any) => {
            element.qsp_row_note_index == noteIdx && element.qsp_row_no == note.row ? this.updateNotesArray.splice(index,1) : ''
           });
        }
        if(Object.keys(json).length !== 0){
          this.updateNotesArray.push(json);
        }
      }
      else {
        if (oldText != this.textArray[index] && this.textArray[index] != "") {
          json = {
            qsp_key: 0,
            qsp_text_id: id,
            qsp_text: this.textArray[index],
            qsp_background_color: note.color,
            qsp_row_no: note.row,
            qsp_workflow_type: 3,
            qsp_fac_key:this.facilityKey,
            qsp_type: qspType,
            qsp_starting_date: this.standardProcessService.getTodayDate(),
            qsp_created_by: this.helperService.decryption(localStorage.getItem(LocalStorage.UId)),
            qsp_created_by_name: this.helperService.decryption(localStorage.getItem(LocalStorage.UName)),
            qsp_created_by_date: '',
            qsp_row_note_index: noteIdx
          };
          }
          if (qspType == 'preworkflow') {
            this.updateNotesArray.forEach((element: any, index: any) => {
              element.qsp_row_note_index == noteIdx && element.qsp_row_no == note.row ? this.updateNotesArray.splice(index,1) : ''
             });
          }
          else if (qspType == 'postworkflow') {
            this.updateNotesArray.forEach((element: any, index: any) => {
              element.qsp_row_note_index == noteIdx && element.qsp_row_no == note.row ? this.updateNotesArray.splice(index,1) : ''
             });
          }
          if(Object.keys(json).length !== 0){
            this.updateNotesArray.push(json);
          }
        }    
    }
  }

  AddUpdatePostVSMData(event: Event, note: note, index: number, qspType: string, id: string,date:string,noteIdx:number,accordian:number){
    this.onClickDisable = false;
    if (event.type == 'blur') {
      let oldText, OldId, OldQspkey;
      let json = {};
      const target = (event.target as HTMLElement);
      let text = target?.innerText.replace(/(?:\r\n|\r|\n)/g, '\n') || '';
      text = text.replace(/\n{2}/g, '\n');
      if (index > -1 && text != 'Save') {
        this.textArray[index] = text;
      }
        this.notespostVSM.map((d: any) => {
          d.value.map((e: any) => {
            e.id.map((f: any) => {
            if (f.id == id) {
              oldText = f.text;
              OldId = f.id;
              OldQspkey = f.qsp_key;
            }
          });
          });
        });
        this.selectDatePostVSM = this.datePipe.transform(this.selectDatePostVSM, 'MM/dd/yyyy');

      if (OldId == id && oldText != this.textArray[index] && OldQspkey != undefined) {
        json = {
          qsp_key: OldQspkey,
          qsp_text_id: id,
          qsp_text: this.textArray[index],
          qsp_background_color: note.color,
          qsp_row_no: note.row,
          qsp_workflow_type: 3,
          qsp_fac_key:this.facilityKey,
          qsp_type: qspType,
          qsp_starting_date: date,
          qsp_modified_by: this.helperService.decryption(localStorage.getItem(LocalStorage.UId)),
          qsp_modified_by_name: this.helperService.decryption(localStorage.getItem(LocalStorage.UName)),
          qsp_modified_by_date: '',
          qsp_row_note_index: noteIdx,
          qsp_accordian:accordian
        };
        this.updateNotesArray.forEach((element: any, index: any) => {
          if(element.qsp_row_note_index == noteIdx && element.qsp_row_no == note.row && element.qsp_starting_date == date){
            this.isPostImplementationVSMFirstTime = true;
          }
          element.qsp_row_note_index == noteIdx && element.qsp_row_no == note.row && element.qsp_starting_date == date ? this.updateNotesArray.splice(index,1) : ''
          
         });      
         if(Object.keys(json).length !== 0){
          this.updateNotesArray.push(json);
         }
        this.updateNotesArray.forEach((element: any, index: any) => {
          if(element.qsp_row_note_index == noteIdx && element.qsp_row_no == note.row && element.qsp_starting_date == date){
            this.isPostImplementationVSMFirstTime = true;
          }
        })
      }
      else {
        if (oldText != this.textArray[index] && this.textArray[index] != "") {
          json = {
            qsp_key: 0,
            qsp_text_id: id,
            qsp_text: this.textArray[index],
            qsp_background_color: note.color,
            qsp_row_no: note.row,
            qsp_workflow_type: 3,
            qsp_fac_key:this.facilityKey,
            qsp_type: qspType,
            qsp_starting_date: date,
            qsp_created_by: this.helperService.decryption(localStorage.getItem(LocalStorage.UId)),
            qsp_created_by_name: this.helperService.decryption(localStorage.getItem(LocalStorage.UName)),
            qsp_created_by_date: '',
            qsp_row_note_index: noteIdx,
            qsp_accordian:accordian
          };
        }
            this.updateNotesArray.forEach((element: any, index: any) => {
             element.qsp_row_note_index == noteIdx && element.qsp_row_no == note.row && element.qsp_starting_date == date ? this.updateNotesArray.splice(index,1) : ''
            });      
            if(Object.keys(json).length !== 0){
              this.updateNotesArray.push(json);
            }
        
      }
    }
  }

  SaveUpdateStandardProcessData(qsp_type:string) {
    let json = {};
    this.selectDatePostVSM = this.datePipe.transform(this.selectDatePostVSM, 'MM/dd/yyyy');
      if(qsp_type == 'preworkflow' && this.isCurrentStateFirstTime == false){
        this.isCurrentStateFirstTime = true;
        this.notespre.forEach((element: any, index: number) => {
          let value = this.updateNotesArray.findIndex((x: any) =>x.qsp_row_no ==  element.row)
          if(value == -1){
            json = {
              qsp_key: 0,
              qsp_text_id: uuidv4(),
              qsp_text: element.id[0].text,
              qsp_background_color: element.color,
              qsp_row_no: element.row,
              qsp_workflow_type: 3,
              qsp_fac_key:this.facilityKey,
              qsp_type: qsp_type,
              qsp_starting_date: this.standardProcessService.getTodayDate(),
              qsp_created_by: this.helperService.decryption(localStorage.getItem(LocalStorage.UId)),
              qsp_created_by_name: this.helperService.decryption(localStorage.getItem(LocalStorage.UName)),
              qsp_created_by_date: '',
              qsp_row_note_index: element.row.index
            };
            this.updateNotesArray.push(json);
          } else if(value != -1){
            json = {
              qsp_key: 0,
              qsp_text_id: uuidv4(),
              qsp_text: element.id[0].text,
              qsp_background_color: element.color,
              qsp_row_no: element.row,
              qsp_workflow_type: 3,
              qsp_fac_key:this.facilityKey,
              qsp_type: qsp_type,
              qsp_starting_date: this.standardProcessService.getTodayDate(),
              qsp_created_by: this.helperService.decryption(localStorage.getItem(LocalStorage.UId)),
              qsp_created_by_name: this.helperService.decryption(localStorage.getItem(LocalStorage.UName)),
              qsp_created_by_date: '',
              qsp_row_note_index: element.row.index
            };
            this.updateNotesArray.push(json);
          }
        })
        
      }
      else if(qsp_type == 'postworkflow' && this.isFutureStateFirstTime == false){
        this.isFutureStateFirstTime = true;
        this.notespost.forEach((element: any, index: number) => {
          let value = this.updateNotesArray.findIndex((x: any) =>x.qsp_row_no ==  element.row)
          if(value == -1){
            json = {
              qsp_key: 0,
              qsp_text_id: uuidv4(),
              qsp_text: element.id[0].text,
              qsp_background_color: element.color,
              qsp_row_no: element.row,
              qsp_workflow_type: 3,
              qsp_fac_key:this.facilityKey,
              qsp_type: qsp_type,
              qsp_starting_date: this.standardProcessService.getTodayDate(),
              qsp_created_by: this.helperService.decryption(localStorage.getItem(LocalStorage.UId)),
              qsp_created_by_name: this.helperService.decryption(localStorage.getItem(LocalStorage.UName)),
              qsp_created_by_date: '',
              qsp_row_note_index: element.row.index
            };
            this.updateNotesArray.push(json);
          }else if(value != -1){
            json = {
              qsp_key: 0,
              qsp_text_id: uuidv4(),
              qsp_text: element.id[0].text,
              qsp_background_color: element.color,
              qsp_row_no: element.row,
              qsp_workflow_type: 3,
              qsp_fac_key:this.facilityKey,
              qsp_type: qsp_type,
              qsp_starting_date: this.standardProcessService.getTodayDate(),
              qsp_created_by: this.helperService.decryption(localStorage.getItem(LocalStorage.UId)),
              qsp_created_by_name: this.helperService.decryption(localStorage.getItem(LocalStorage.UName)),
              qsp_created_by_date: '',
              qsp_row_note_index: element.row.index
            };
            this.updateNotesArray.push(json);
          }
        })
        
      }
      else if (qsp_type == 'postworkflowVSM' && this.isPostImplementationVSMFirstTime == false) {
        this.isPostImplementationVSMFirstTime = true;
        localStorage.setItem('isPostImplementationVSMFirstTime',JSON.stringify(true))
        this.notespostVSM.map((d: any) => {
          this.storePreviousDateVSM = d.date;
          d.value.map((element: any) => {
            
            let value = this.updateNotesArray.findIndex((x: any) => x.qsp_row_no == element.row && x.qsp_starting_date == d.date && x.qsp_accordian == d.accordion)
            let checkDate = this.updateNotesArray.findIndex((x: any) =>  x.qsp_starting_date == d.date)
            if(checkDate != -1){
            if (value == -1) {
              json = {
                qsp_key: 0,
                qsp_text_id: uuidv4(),
                qsp_text: element.id[0].text,
                qsp_background_color: element.color,
                qsp_row_no: element.row,
                qsp_workflow_type: 3,
                qsp_fac_key: this.facilityKey,
                qsp_type: qsp_type,
                qsp_starting_date: d.date,
                qsp_created_by: this.helperService.decryption(localStorage.getItem(LocalStorage.UId)),
                qsp_created_by_name: this.helperService.decryption(localStorage.getItem(LocalStorage.UName)),
                qsp_created_by_date: '',
                qsp_row_note_index: element.row.index,
                qsp_accordian:d.accordian
              };
              this.updateNotesArray.push(json);
            }else if (value != -1) {
              json = {
                qsp_key: 0,
                qsp_text_id: uuidv4(),
                qsp_text: element.id[0].text,
                qsp_background_color: element.color,
                qsp_row_no: element.row,
                qsp_workflow_type: 3,
                qsp_fac_key: this.facilityKey,
                qsp_type: qsp_type,
                qsp_starting_date: d.date,
                qsp_created_by: this.helperService.decryption(localStorage.getItem(LocalStorage.UId)),
                qsp_created_by_name: this.helperService.decryption(localStorage.getItem(LocalStorage.UName)),
                qsp_created_by_date: '',
                qsp_row_note_index: element.row.index,
                qsp_accordian:d.accordian
              };
              this.updateNotesArray.push(json);
            }
          }
          });
        });
      }
      if (this.updateNotesArray.length > 0) {
        this.showProgressSpinner = true;
        this.subscription.push(
          this.standardProcessService
            .InsertUpdateStandardProcess(3, this.facilityKey, this.updateNotesArray)
            .subscribe({
              next: (res: any) => {
                this.showProgressSpinner = false;
                this.noForAccordian = 0;
                this.notespre = [];
                this.notespost = [];
                this.notespostVSM = [];
                this.getStickyNotesData = res.data;
                this.getSavedData();
                this.toastService.message('Notes Save Successfully.');
                this.updateNotesArray = [];
              },
              error: (err: any) => {
              },
            })
        );
      } else {
       this.updateNotesArray 
      }
  }

  DeleteNote(note: string, type: string, workflowType: string,row:number) {
    this.noteID = note;
    this.workflowType = workflowType;
    this.type = type;
    this.rowNO = row;
    this.unique_Id = '';
    this.messageService.clear();
    this.messageService.add({
      key: 'c',
      sticky: true,
      severity: 'custom',
      summary: 'Are you sure you want to delete?',
    });
  }

  OnConfirm() {
    this.deletePostVsmAccordionBool = false;
    this.showProgressSpinner = true;
    if(this.unique_Id){
      this.subscription.push(
      this.standardProcessService.DeleteFileUploadStandardProcess(this.unique_Id).subscribe({
        next: (res: any) => {
          this.showProgressSpinner = false;
          this.getFileUploadStandardProcessArray.forEach((item:any,index:any)=>{
            if(item.qfs_Id == this.unique_Id){
              this.getFileUploadStandardProcessArray.splice(index, 1)
            }
          })
          this.toastService.message('File Delete Successfuly.');
        },
        error: (err: any) => {
        },
      })
      );
    }else{

    if(this.type == 'pre'){
      var oldText, idd, key,row: any;
      this.notespre.map((d: any) => { d.id.map((e: any) => {
          if (d.row == this.rowNO && e.id == this.noteID) {
            oldText = e.text;
            idd = e.id;
            key = e.qsp_key;
          }
        });
        if(d.row == this.rowNO){
          row = d.row;
        }
      });
    }
    else if(this.type == 'post')
    {
      var oldText, idd, key;
      this.notespost.map((d: any) => { d.id.map((e: any) => {
          if (e.id == this.noteID) {
            oldText = e.text;
            idd = e.id;
            key = e.qsp_key;
          }
        });
        if(d.row == this.rowNO){
          row = d.row;
        }
      });
    }
    else if(this.type == 'VSM')
    {
      var oldText, idd, key;
      this.notespostVSM.map((d: any) => {
          d.value.map((e: any) => {
            e.id.map((f: any) => {
            if (f.id == this.noteID) {
              oldText = f.text;
              idd = f.id;
              key = f.qsp_key;
            }
          });
          if(e.row == this.rowNO){
            row = e.row;
          }
          });
        });
    }
    if(oldText == '' && this.rowNO == row){
      if (this.type == 'pre') {
        this.notespre.map((d: any, i: any) =>
          d.id.map((e: any, j: any) =>{

            this.updateNotesArray.map((val:any,ind:any)=>{
              if(val.qsp_text != e.text && val.qsp_text_id == e.id){
                val.qsp_text_id == e.id ? this.updateNotesArray.splice(ind,1):'';
              }
            });

            e.id == this.noteID ? this.notespre[i].id.splice(j, 1) : ''
          }
          )
        );
        this.toastService.message('Current State Delete Successfuly.');
      } 
      else if (this.type == 'post') {
        this.notespost.map((d: any, i: any) =>
          d.id.map((e: any, j: any) =>
            e.id == this.noteID ? this.notespost[i].id.splice(j, 1) : ''
          )
        );
        this.toastService.message('Future State Deleted Successfuly.');
      }
      else if (this.type == 'VSM') {
        this.notespostVSM.map((d: any,h: any) => {
          d.value.map((e: any, i: any) => {
            e.id.map((f: any, j: any) => {
              
              this.updateNotesArray.map((val:any,ind:any)=>{
                if(val.qsp_text != f.text && val.qsp_text_id == f.id){
                  val.qsp_text_id == f.id ? this.updateNotesArray.splice(ind,1):'';
                }
              })

              f.id == this.noteID ? this.notespostVSM[h].value[i].id.splice(j, 1) : '';
             
          });
          });
        });
        
        this.toastService.message('Post implementation VSM Deleted Successfuly.');
      }
      this.showProgressSpinner = false;
    }
    else
    {
        this.subscription.push(
          this.standardProcessService
            .DeleteStandardProcessNote(this.noteID, 3, this.workflowType, Number(this.rowNO), this.facilityKey)
            .subscribe({
              next: (res: any) => {
                this.showProgressSpinner = false;
                if (this.type == 'pre') {
                  this.notespre.map((d: any, i: any) =>
                    d.id.map((e: any, j: any) =>
                      e.id == this.noteID ? this.notespre[i].id.splice(j, 1) : ''
                    )
                  );
                  this.toastService.message('Current State Deleted Successfuly.');
                }
                else if (this.type == 'post') {
                  this.notespost.map((d: any, i: any) =>
                    d.id.map((e: any, j: any) =>
                      e.id == this.noteID ? this.notespost[i].id.splice(j, 1) : ''
                    )
                  );
                  this.toastService.message('Future State Deleted Successfuly.');
                }
                else if (this.type == 'VSM') {
                  this.notespostVSM.map((d: any, h: any) => {
                    d.value.map((e: any, i: any) => {
                      e.id.map((f: any, j: any) => {
                        f.id == this.noteID ? this.notespostVSM[h].value[i].id.splice(j, 1) : ''
                      });
                    });
                  });
                  this.toastService.message('Post implementation VSM Deleted Successfuly.');
                }
              },
              error: (err: any) => { },
            })
        );
    }
  }
    this.messageService.clear();
  }
  
  OnReject() {
    this.messageService.clear();
  }

  AddNewCellInRow(rowNUM: number, type: string,accordion:any,index:any) {
    var findIndex = this.notespre.findIndex((x: any) => x.row == rowNUM);
    if (type.toLowerCase() == 'preworkflow') {
      var findIndex = this.notespre.findIndex((x: any) => x.row == rowNUM);

      this.notespre[findIndex].id.push({
        id: (uuidv4()),
        text: ''
      });
    }
    else if (type.toLowerCase() == 'postworkflow') {
      this.notespost[rowNUM - 1].id.push({
        id: (uuidv4()),
        text: ''
      });
    }
    else if (type == 'postimplementationVSM') {
    var findIndexVSM = this.notespostVSM.map((x:any) => x.value.filter((y:any)=>y.row == rowNUM));
      
          findIndexVSM[index][0].id.push({
              id: (uuidv4()),
              text: ''
            })
        
    }
    // this.rowArray = [];
  }

  ChangeTableRowColor(idx: number) {
    if (this.rowClicked === idx) this.rowClicked = -3;
    else this.rowClicked = idx;
  }

  AddDefaultPreWorkFlow() {
    this.rowArrayPre = [];
    this.No = this.notespre.length;
    const sections = [
      { color: '#9163ab', defaultText: 'Procedure' },
      { color: '#84eb54', defaultText: 'Special Process' },
      { color: '#13b3ed', defaultText: 'Process Step' },
      { color: '#ff9c12', defaultText: 'Roles' },
      { color: '#f5d94e', defaultText: 'Cycle Times' },
      { color: '#f0d8b1', defaultText: 'Timeline' }
    ];
    
    for (this.No; this.No < 6; this.No ++) {
      const section = sections[this.No];
      this.rowArrayPre.push({ id: this.No + 1, col: 1, color: section.color, new: section.defaultText });
    }
    this.historyBool = false;
    for (let i = 0; i < this.rowArrayPre.length; i++) {
      this.notespreTemp = [];
      for (let j = 0; j < this.rowArrayPre[i].col; j++) {
        this.notespreTemp.push({ id: uuidv4(), text: this.rowArrayPre[i].new });
      }
      this.notespre.push({
        row: this.rowArrayPre[i].id,
        id: this.notespreTemp,
        color: this.rowArrayPre[i].color,
      });
    }

    if (this.notespre.length > 0) {
    }
  }

  AddDefaultPostWorkFlow() {
    this.rowArrayPost = [];
    this.No = this.notespost.length;
    for (this.No; this.No < 3; this.No++) {
      if(this.No== 0){
        this.colorScheme = '#13b3ed';
        this.defaultText = 'Process step';
     }else if(this.No == 1){
       this.colorScheme = '#84eb54';
       this.defaultText = 'Roles';
     }
     else if(this.No == 2){
       this.colorScheme = '#9163ab';
       this.defaultText = 'Special Process';
     }
      this.rowArrayPost.push({id: this.No + 1, col:1, color : this.colorScheme, new: this.defaultText});
    }
    this.postBool = false;
    for (let i = 0; i < this.rowArrayPost.length; i++) {
      this.notespostTemp = [];
      for (let j = 0; j < this.rowArrayPost[i].col; j++) {
        this.notespostTemp.push({ id: uuidv4(), text: this.rowArrayPost[i].new });
      }
      this.notespost.push({
        row: this.rowArrayPost[i].id,
        id: this.notespostTemp,
        color: this.rowArrayPost[i].color,
      });
    }
    if (this.notespost.length > 0) {
    }
  }

  AddDefaultPostImplementationVSM() {
    this.selectDatePostVSM = this.datePipe.transform(this.selectDatePostVSM, 'MM/dd/yyyy');
    let findIndex = this.notespostVSM.findIndex((x: any) => x.date == this.selectDatePostVSM);
    if (findIndex == -1) {
      this.AddPostVSMBool = true;
      this.rowArrayPostVSM = [];
      this.notespostVSMForRowAndID = [];
      for (this.No = 0; this.No < 3; this.No++) {
        if (this.No == 0) {
          this.colorScheme = '#13b3ed';
          this.defaultText = 'Process step';
        } else if (this.No == 1) {
          this.colorScheme = '#84eb54';
          this.defaultText = 'Roles';
        }
        else if (this.No == 2) {
          this.colorScheme = '#9163ab';
          this.defaultText = 'Special Process';
        }
        this.rowArrayPostVSM.unshift({ id: this.rowArrayPostVSM.length + 1, col: 1, color: this.colorScheme, new: this.defaultText });
      }
      this.postBool = false;
      for (let i = 0; i < this.rowArrayPostVSM.length; i++) {
        this.notespostVSMTemp = [];
        for (let j = 0; j < this.rowArrayPostVSM[i].col; j++) {
          this.notespostVSMTemp.unshift({ id: uuidv4(), text: this.rowArrayPostVSM[i].new });
        }
        this.notespostVSMForRowAndID.unshift({
          row: this.rowArrayPostVSM[i].id,
          id: this.notespostVSMTemp,
          color: this.rowArrayPostVSM[i].color,
        });
      }
      this.notespostVSM.unshift({
        accordion: this.notespostVSM.length + 1,
        value: this.notespostVSMForRowAndID,
        date: this.selectDatePostVSM
      });
    } else {
      this.messageService.add({
        key: 'save',
        severity: 'error',
        summary: 'This date accordian already existed.',
      });
    }
    this.isPostImplementationVSMFirstTime = false;
  } 

  
  navigateToPage(event:any){
    if (event.value == 'Inpatient') {
      this.standardProcessService._routeToComponent('Inpatient', this.facilityKey, this.implentationType);
    } else if (event.value == 'Triage/Walk-In') {
      this.standardProcessService._routeToComponent('Triage/Walk-In', this.facilityKey, this.implentationType);
    } else if (event.value == 'EMS') {
      this.standardProcessService._routeToComponent('EMS', this.facilityKey, this.implentationType);
    }
    else if (event == "childComponentNavigate") {
      this.standardProcessService._routeToComponent(this.childComponentNavigate, '', true);
    }
    this.GetBackRouteSearchValue();
  }
  GetBackRouteSearchValue() {
    let passedFacility = this.defineService.GetSearchFacility().passedFacility;
    this.defineService.PassingSearchFacility(passedFacility, true);
  }


  SlidePrePost(direction:string,type:string){
    this.downloadHelper.SlidePrePostImplementation(direction, type);
}

SaveFileUploadData(){
  this.triageFileLoader = true;
  if(this.selectedFilesBase64Array.selectedFilesBase64Array.length > 0){
    this.subscription.push(
  this.standardProcessService.SaveFileUploadStandardProcess(this.selectedFilesBase64Array.selectedFilesBase64Array).subscribe({
    next: (res: any) => {
      if(res.msg == "Sucess"){
        this.standardProcessService._standerdProcessComponent.FileUploadComponent.ClearUploadedFileEvent();
        this.triageFileLoader = false;
        this.ViewDownloadedDocument();
        this.UploadDocBool = true;
        this.toastService.message('Document Save Successfuly.');
      }
    },
    error: (err: any) => { },
  })
  );
}else{
  this.triageFileLoader = false;
  this.messageService.add({
    key: 'save',
    severity: 'error',
    summary: 'Please select document first.',
  }); 
  }
 
}

async ViewDownloadedDocument(){
  try {
    this.getFileUploadStandardProcessArray = await (await this.downloadHelper.GetViewDownloadedDocument(this.facilityKey, 3, this.pageTittleName)).toPromise();
    if(this.getFileUploadStandardProcessArray){
      this.totalRecords = this.getFileUploadStandardProcessArray.length;
    }
  } catch (error) {
    console.error('Error fetching data:', error);
  }
}

showDownloadDocument($event:any){
  this.downloadHelper.showDownloadDocument($event, this.getFileUploadStandardProcessArray);
}

DeleteDownloadDocument(unique_Id:any){
  this.unique_Id = unique_Id;
  this.messageService.clear();
    this.messageService.add({
      key: 'c',
      sticky: true,
      severity: 'custom',
      summary: 'Are you sure you want to delete?',
    });
}

  deleteTab(event: Event, index: number, newNoteForRow: any, type: any, deleteTabBool: any) {
  event.stopPropagation();
  this.type = type;
  this.accordionNo = newNoteForRow.accordion;
  this.accordionDate = newNoteForRow.date;

  this.messageService.clear();
  this.messageService.add({
    key: 'd',
    sticky: true,
    severity: 'custom',
    summary: 'Are you sure you want to delete?',
  });
}

OnConfirmAccordion(){
  this.deletePostVsmAccordionBool= false;
  this.notespostVSM.map((d: any) => {
      d.value.map((e: any) => {
        e.id.map((f: any) => {
          if (e.id.length >= 1 && f.text !== "" && this.accordionNo == d.accordion && f.qsp_key != 0 && d.date == this.accordionDate && this.getStickyNotesData.find((x: any) => new Date(x.qsp_starting_date).toLocaleDateString() == new Date(this.accordionDate).toLocaleDateString() && x.qsp_type.toLowerCase() != "preworkflow") != undefined) {
          this.deletePostVsmAccordionBool= true;
        }
      });
      });
    });

    if (this.deletePostVsmAccordionBool && this.type == 'VSM') {
      this.subscription.push(
        this.standardProcessService
          .DeleteStandardProcessVSMAccordion(this.accordionDate, 3, this.facilityKey)
          .subscribe({
            next: (res: any) => {

              this.notespostVSM.map((d: any, h: any) => {
                d.accordion == this.accordionNo ? this.notespostVSM.splice(h,1) : '';
              });
              this.getStickyNotesData = res.data;

              this.showProgressSpinner = false;
              this.toastService.message('Accordion Deleted Successfuly.');
            },
            error: (err: any) => { },
          })
      );

    } else if (!this.deletePostVsmAccordionBool && this.type == 'VSM') {
      this.notespostVSM.map((d: any, h: any) => {
        d.accordion == this.accordionNo ? this.notespostVSM.splice(h,1) : '';
      });
      this.showProgressSpinner = false;
      this.toastService.message('Accordion Deleted Successfuly.');
    }
    this.messageService.clear();
}


ngOnDestroy() {
  if(this.subscription.length != 0){
    this.subscription.forEach((i:any)=>{
      i.unsubscribe();
    })
  }

  Object.getOwnPropertyNames(this)
  .filter(propName => Array.isArray((<any>this)[propName]))
  .forEach(propName => (<any>this)[propName] = []);

}
}

